import React from 'react';
import { AlignTypesHorizontal } from '../../../../../shared/enums/AlignTypesHorizontal';
import ScreensAdditionalAction from '../../additional-action/ScreensAdditionalAction';

export const screensPageAdditionalAction = {
  alignTypeHorizontal: AlignTypesHorizontal.Start,
  component: <ScreensAdditionalAction />,
};
